import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import ebooksSectionManagementService from "../../services/EBooksSectionManagement";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const EBooksSection = () => {
  return (
    <ContentManagement
      service={ebooksSectionManagementService}
      pageSize={10}
      sidebarItemLayout="ebook"
      contentType={CONTENT_TYPES_CONFIG.E_BOOK}
      // use the ebook title as the slug
      getSlug="title"
    />
  );
};

export default EBooksSection;